/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { WithTooltipProps } from "../withTooltip";

const BLACKLISTED_PROP_NAMES: Readonly<{ [key in keyof WithTooltipProps]: `${key}` }> = {
    ignoreTooltip: "ignoreTooltip",
    tooltip: "tooltip",
    tooltipIconColor: "tooltipIconColor"
} as const;

const BLACKLIST: ReadonlySet<string> = new Set(Object.values(BLACKLISTED_PROP_NAMES));

export default function ignoreWithTooltipProps<Props extends {}>(Component: React.ComponentType<Props>) {
    return (props: Props) => {
        const cleanedProps = Object.entries(props).reduce((acc, [key, value]) => {
            if (BLACKLIST.has(key)) {
                return acc;
            }

            return { ...acc, [key]: value };
        }, {} as Props)
        return <Component {...cleanedProps} />;
    }
}